import React, { useEffect } from 'react';
import contactRef from '../../components/Footer/Footer';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './HowItWorksPage.module.css';
import * as PropTypes from 'prop-types';

const HowItWorksPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  // prettier-ignore
  return (
    <StaticPage
      title="How It Works Page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowItWorksPage',
        description: 'How It Works',
        name: 'How It Works',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>How It Works.</h1>
              <h2>Buying on WeCycle: The parts you want, when you want them.</h2>

            <ol>
              <li>Log into your WeCycle account.</li>
              <li>Open the item you'd like to purchase.</li>
              <li>Click "Buy".</li>
              <li>Add your payment info and checkout.</li>
              <li>Congratulations! Your new gear is on its way!</li>
              <li>You'll get an email from us to confirm your purchase and can view your purchased receipt.</li>
            </ol>

          <h2>Selling on WeCycle: Sell. Get paid. Repeat.</h2>

            <ol>
              <li>Log into your WeCycle account.</li>
              <li>Click "+ Post a new listing", describe your item and upload photos in seconds!</li>
              <li>Once a Buyer initiates a transaction, you will have up to 3 days to accept the offer.</li>
              <li>Cha-Ching. You'll get an email from us to confirm the sale and simple steps for a smooth transaction.
              </li>
            </ol>

            <p>Still have questions? E-mail us at:<ExternalLink href="mailto:info@wecycleshop.com">info@wecycleshop.com</ExternalLink>.</p>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>

  );
};

export default HowItWorksPage;

